import { render, staticRenderFns } from "./CallCount.vue?vue&type=template&id=f8915afe&scoped=true"
import script from "./CallCount.vue?vue&type=script&lang=js"
export * from "./CallCount.vue?vue&type=script&lang=js"
import style0 from "./CallCount.vue?vue&type=style&index=0&id=f8915afe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8915afe",
  null
  
)

export default component.exports